class Staff {
  init() {
    this.staffLinks = document.querySelectorAll("[js-staff-link]");
    this.hash = window.location.hash;

    this.staffActions();
  }

  staffActions() {
    if (this.hash && this.staffLinks.length) {
      const id = this.hash.replace("#", "");

      this.staffToggle(id);
    }

    if (this.staffLinks.length) {
      this.staffLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();

          if (!link.classList.contains("is-active")) {
            const id = link.getAttribute("href");

            this.staffToggle(id);
          }
        });
      });
    }
  }

  staffToggle(id) {
    if (id) {
      const activeLink = document.querySelector(".staff__tab.is-active");
      const activeDepartment = document.querySelector(".staff__department.is-active");

      const activateLink = document.querySelector(`.staff__tab--${id}`);
      const activateDepartment = document.querySelector(`#${id}`);

      activeLink.classList.remove("is-active");
      activeDepartment.classList.remove("is-active");

      activateLink.classList.add("is-active");
      activateDepartment.classList.add("is-active");
    }
  }
}

export default Staff;



// WEBPACK FOOTER //
// ./scripts/Staff.js